// App store length guidelines - https://help.apple.com/app-store-connect/#/devf29afbb74
// Play store length guidelines - https://support.google.com/googleplay/android-developer/answer/9859152?hl=en-GB#zippy=%2Cmaximum-size-limit%2Cproduct-details
// 30 app store, 50 play store
export const NAME_MAX_LENGTH = 30;
// 4000 play store, 4000 app store
export const DESCRIPTION_MAX_LENGTH = 4000;
// 170 app store, 80 play store
export const SHORT_DESCRIPTION_MAX_LENGTH = 80;

export const KEYWORDS_MAX_LENGTH = 100;

export const KEYWORD_MIN_LENGTH = 2;
